export default __webpack_public_path__ + "static/media/pet-treatment.0f5c5e95.png";